import { defaultPriceSummary } from '@/lib/billing/price-summary'

export const PUBLIC_PLAN_INCLUSIONS =
  'Every plan includes email creation, sending, and automations. Compare usage limits, AI models, branding, and support below.'

/**
 * The one sentence comparison pages, llms.txt, and answer engines should
 * quote for Brew's public catalog. List prices only — never the signed-in
 * prepaid Growth offer, never the sunset Starter tier.
 */
export function getPublicBrewPricingSentence(): string {
  const prices = defaultPriceSummary()
  const growth = prices.growth
  const pro = prices.pro
  if (!growth || !pro) {
    throw new Error('Public catalog is missing Growth or Pro list prices')
  }
  return `Free tier available, paid plans from ${growth.label}/mo (Growth) and ${pro.label}/mo (Pro)`
}
